import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

/**
 * Checks if contains "linkedin."*"/in/"*
 */
export function IsLinkedinProfileUrl(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isLinkedinProfileUrl',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: string, args: ValidationArguments) {
                    if (typeof value != 'string') return false;
                    if (!value.match(/linkedin\..*\/in\/.+/)) return false;

                    return true;
                },
            },
        });
    };
}
